import { FC } from "react";
import { Row, Col } from "react-bootstrap";
import { TablePagerInfo } from "./pager-info";
import { TablePagerNav } from "./pager-nav";

export const TablePager: FC = () => {
  return (
    <Row>
      <Col className="mb-3">
        <TablePagerNav />
      </Col>
      <Col className="mb-3">
        <TablePagerInfo />
      </Col>
    </Row>
  );
};
